import { motion, type Transition, type Variants } from 'framer-motion'
import { twMerge } from 'tailwind-merge'
import { useMiniNotchRegion } from './notch-region'

const NOTCH_CORNER_CLASS = 'rounded-b-[12px]'

const snapRegionVariants: Variants = {
  hidden: { opacity: 0, scaleY: 0.85 },
  visible: { opacity: 1, scaleY: 1 },
}

const snapRegionTransition: Transition = { duration: 0.18, ease: 'easeOut' }

export function MiniNotchSnapRegion() {
  const region = useMiniNotchRegion()

  return (
    <motion.div
      className={twMerge(
        'pointer-events-none absolute top-0 origin-top bg-black/60 outline-dashed outline-2 outline-white/70',
        NOTCH_CORNER_CLASS,
      )}
      style={{ left: region.x, width: region.width, height: region.height }}
      variants={snapRegionVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      transition={snapRegionTransition}
    />
  )
}
